(function () {
  'use strict';
  var ROOT = '[data-ws-bundle-configurator]';
  var CACHE = 'ws-bundle-component-v8:';

  function norm(value) { return String(value || '').trim().toLocaleLowerCase('it-IT').normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
  function keyNorm(value) { return norm(value).replace(/[^a-z0-9]+/g, ' ').trim(); }
  function toInt(value) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) || parsed < 0 ? 0 : parsed;
  }
  function parsePackLimits(raw) {
    var limits = {};
    String(raw || '').replace(/^\s*\[|\]\s*$/g, '').split(/\|\||,/).forEach(function (entry) {
      var clean = entry.replace(/^\s*["']|["']\s*$/g, '').trim();
      var separator = Math.max(clean.lastIndexOf(':'), clean.lastIndexOf('='));
      if (separator < 0) return;
      var key = clean.slice(0, separator).trim(), limit = toInt(clean.slice(separator + 1));
      if (key && limit > 0) limits[key] = limit;
    });
    return limits;
  }
  function packKeyForTitle(title, limits) {
    var normalizedTitle = keyNorm(title);
    var keys = Object.keys(limits);
    var aliases = [
      { match: 't shirt', key: 't shirt' },
      { match: 'felpa', key: 'felp' },
      { match: 'gilet', key: 'gilet' }, { match: 'giacc', key: 'giacc' }, { match: 'pantalon', key: 'pantalon' }
    ];
    var alias = aliases.find(function (item) { return normalizedTitle.indexOf(item.match) >= 0; });
    if (alias) {
      var matched = keys.find(function (key) { return keyNorm(key).indexOf(alias.key) >= 0; });
      if (matched) return matched;
    }
    return keys.find(function (key) {
      var subject = keyNorm(key).replace(/^taglie?\s+/, '');
      return subject && normalizedTitle.indexOf(subject) >= 0;
    }) || '';
  }
  function json(root, selector, fallback) {
    try { return JSON.parse(root.querySelector(selector).textContent); } catch (error) { return fallback; }
  }
  function assignedJSON(source, name) {
    var at = source.indexOf('var ' + name);
    var equal = at < 0 ? -1 : source.indexOf('=', at);
    if (equal < 0) return null;
    var start = equal + 1;
    while (/\s/.test(source.charAt(start))) start += 1;
    var open = source.charAt(start);
    var close = open === '[' ? ']' : open === '{' ? '}' : '';
    if (!close) return null;
    var depth = 0, quoted = false, escaped = false;
    for (var i = start; i < source.length; i += 1) {
      var character = source.charAt(i);
      if (quoted) {
        if (escaped) escaped = false;
        else if (character === '\\') escaped = true;
        else if (character === '"') quoted = false;
      } else if (character === '"') quoted = true;
      else if (character === open) depth += 1;
      else if (character === close && --depth === 0) {
        try { return JSON.parse(source.slice(start, i + 1)); } catch (error) { return null; }
      }
    }
    return null;
  }
  function readVopo(html) {
    var documentCopy = new DOMParser().parseFromString(html, 'text/html');
    var scripts = Array.prototype.slice.call(documentCopy.scripts);
    for (var i = 0; i < scripts.length; i += 1) {
      var source = scripts[i].textContent || '';
      if (source.indexOf('var bcpo_data') >= 0) {
        var data = assignedJSON(source, 'bcpo_data');
        if (data && Array.isArray(data.virtual_options)) return data.virtual_options;
      }
      if (source.indexOf('var bcpo_options') >= 0) {
        var legacy = assignedJSON(source, 'bcpo_options');
        if (Array.isArray(legacy)) return legacy;
      }
    }
    return [];
  }
  function optionTitle(option) { return norm(option && (option.title || option.name || option.label)); }
  function values(option) { return Array.isArray(option && option.values) ? option.values : []; }
  function valueLabel(value) {
    return typeof value === 'string' ? value : value && (value.label || value.name || value.title || value.key || value.value) || '';
  }
  function valueImage(value) {
    if (typeof value !== 'object' || !value) return '';
    var candidate = value.image || value.image_url || value.src || value.key_image || value.value || '';
    return /^https?:\/\/|^\/\//.test(candidate) ? candidate : '';
  }
  function valuePriceCents(value) {
    if (typeof value !== 'object' || !value || value.price == null || value.price === '') return 0;
    var amount = parseFloat(String(value.price).replace(/\s+/g, '').replace(',', '.'));
    return isNaN(amount) ? 0 : Math.round(amount * 100);
  }
  function findOption(options, term) {
    return options.find(function (option) {
      if (optionTitle(option).indexOf(term) >= 0) return true;
      if (term !== 'taglia' || option.type !== 'instructions') return false;
      var firstValue = values(option)[0];
      var instructions = option.instructions || firstValue && firstValue.key || '';
      return norm(instructions).indexOf('taglia') >= 0 || instructions.indexOf('ws-sizes') >= 0;
    });
  }
  function sizesFrom(option) {
    var list = values(option);
    var html = option && option.instructions || '';
    if (!html && list[0] && typeof list[0] === 'object') html = list[0].instructions || list[0].key || '';
    if (!html || html.indexOf('<') < 0) {
      return list.map(function (value) { var label = valueLabel(value); return { code: label, name: label }; }).filter(function (item) { return item.name; });
    }
    var copy = new DOMParser().parseFromString(html, 'text/html');
    return Array.prototype.slice.call(copy.querySelectorAll('.ws-sizes__item,[data-size],.size-row')).map(function (row) {
      var badge = row.querySelector('.ws-sizes__badge,[data-size-code],.size-code');
      var name = row.querySelector('.ws-sizes__name,[data-size-name],.size-name');
      var code = badge ? badge.textContent.trim() : row.getAttribute('data-size') || '';
      return { code: code || row.textContent.trim(), name: name ? name.textContent.trim() : row.textContent.trim() };
    }).filter(function (item, index, all) {
      return item.name && all.findIndex(function (other) { return norm(other.code) === norm(item.code); }) === index;
    });
  }
  function isOneSizeOption(option) {
    var sizes = sizesFrom(option);
    if (sizes.length !== 1) return false;
    var code = norm(sizes[0].code), name = norm(sizes[0].name);
    return /^(unica|taglia unica|one size|tu)$/.test(code) || /^(unica|taglia unica|one size)$/.test(name);
  }
  function loadComponent(title, handle) {
    try {
      var cached = sessionStorage.getItem(CACHE + norm(title));
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch (error) {}
    function readProduct(url) {
      return fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Prodotto base non disponibile');
        return response.text();
      }).then(function (html) {
        var result = { options: readVopo(html) };
        return result;
      });
    }
    function searchProduct() {
      var parameters = new URLSearchParams();
      parameters.set('q', title);
      parameters.set('resources[type]', 'product');
      parameters.set('resources[limit]', '10');
      parameters.set('resources[options][unavailable_products]', 'show');
      return fetch('/search/suggest.json?' + parameters, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Ricerca prodotto non disponibile');
        return response.json();
      }).then(function (payload) {
        var products = payload && payload.resources && payload.resources.results && payload.resources.results.products || [];
        var product = products.find(function (candidate) { return norm(candidate.title) === norm(title); }) || products[0];
        if (!product || !product.url) throw new Error('Prodotto base non trovato');
        return readProduct(product.url.split('?')[0]);
      });
    }
    var directHandle = handle || keyNorm(title).replace(/\s+/g, '-');
    return readProduct('/products/' + directHandle).catch(searchProduct).then(function (result) {
      try { sessionStorage.setItem(CACHE + norm(title), JSON.stringify(result)); } catch (error) {}
      return result;
    });
  }
  function loadBundleComponents(variantId) {
    var query = 'query BundleComponents($id: ID!) { node(id: $id) { ... on ProductVariant { components(first: 20) { nodes { quantity productVariant { id selectedOptions { name value } product { title handle options { name values } } } } } } } }';
    return fetch('/api/2026-07/graphql.json', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: query, variables: { id: 'gid://shopify/ProductVariant/' + variantId } })
    }).then(function (response) {
      if (!response.ok) throw new Error('Collegamento al prodotto base non disponibile');
      return response.json();
    }).then(function (payload) {
      var nodes = payload && payload.data && payload.data.node && payload.data.node.components && payload.data.node.components.nodes || [];
      if (!nodes.length) throw new Error('Prodotti del bundle non trovati');
      return nodes.map(function (component) {
        var variant = component.productVariant || {}, product = variant.product || {};
        if (!product.title || !product.handle) throw new Error('Dati del prodotto base incompleti');
        var selectedOptions = variant.selectedOptions || [];
        return {
          title: product.title,
          handle: product.handle,
          quantity: component.quantity || 1,
          nativeOptions: selectedOptions.map(function (selection) {
            return { name: selection.name, values: [selection.value] };
          }),
          selectedOptions: selectedOptions
        };
      });
    });
  }
  function fieldLabel(text, paths, value) {
    var node = document.createElement('div');
    node.className = 'ws-bundle-field__label';
    node.innerHTML = '<span class="ws-bundle-field__icon" aria-hidden="true"><svg viewBox="0 0 24 24">' + paths + '</svg></span><span data-ws-bundle-field-title></span><span class="ws-bundle-field__value" data-ws-bundle-field-value></span>';
    node.querySelector('[data-ws-bundle-field-title]').textContent = text;
    node.querySelector('[data-ws-bundle-field-value]').textContent = value || '';
    return node;
  }
  function renderPosition(parent, option, state, changed) {
    var optionValues = values(option);
    if (!optionValues.length) return false;
    var field = document.createElement('div'), wrap = document.createElement('div'), select = document.createElement('select');
    field.className = 'ws-bundle-field'; wrap.className = 'ws-bundle-select-wrap'; select.setAttribute('data-ws-bundle-position', '');
    var label = fieldLabel('Posizione stampa:', '<circle cx="12" cy="12" r="7"></circle><path d="M12 2v3M12 19v3M2 12h3M19 12h3"></path>');
    optionValues.forEach(function (value) {
      var text = valueLabel(value);
      if (!text) return;
      var optionNode = document.createElement('option'); optionNode.value = text; optionNode.textContent = text; select.appendChild(optionNode);
    });
    if (!select.options.length) return false;
    state.position = select.value; label.querySelector('[data-ws-bundle-field-value]').textContent = state.position;
    select.addEventListener('change', function () {
      state.position = select.value; label.querySelector('[data-ws-bundle-field-value]').textContent = state.position; changed();
    });
    wrap.appendChild(select); field.appendChild(label); field.appendChild(wrap); parent.appendChild(field); return true;
  }
  function renderShape(parent, option, state, changed) {
    if (!values(option).length) return false;
    var field = document.createElement('div'), choices = document.createElement('div');
    field.className = 'ws-bundle-field'; choices.className = 'ws-bundle-colours ws-bundle-shapes'; choices.setAttribute('role', 'group');
    var shapeLabel = fieldLabel('Forma Toppa:', '<path d="M5 4h14v16H5z"></path><circle cx="12" cy="12" r="5"></circle>');
    field.appendChild(shapeLabel);
    values(option).forEach(function (value, index) {
      var label = valueLabel(value), image = valueImage(value), button = document.createElement('button');
      if (!label) return;
      button.type = 'button'; button.className = 'ws-bundle-colour'; button.title = label; button.setAttribute('aria-label', label);
      button.setAttribute('aria-pressed', state.shape ? String(norm(state.shape) === norm(label)) : String(index === 0));
      button.innerHTML = image ? '<img loading="lazy" alt="">' : '<span></span>';
      if (image) { button.firstElementChild.src = image; button.firstElementChild.alt = label; } else button.firstElementChild.textContent = label;
      button.addEventListener('click', function () {
        Array.prototype.forEach.call(choices.children, function (item) { item.setAttribute('aria-pressed', 'false'); });
        button.setAttribute('aria-pressed', 'true'); state.shape = label; shapeLabel.querySelector('[data-ws-bundle-field-value]').textContent = label; changed();
      });
      choices.appendChild(button);
      if (!state.shape && index === 0) state.shape = label;
    });
    shapeLabel.querySelector('[data-ws-bundle-field-value]').textContent = state.shape;
    field.appendChild(choices); parent.appendChild(field); return true;
  }
  function renderColours(parent, option, state, changed, customLabel) {
    if (!values(option).length) return false;
    var field = document.createElement('div'), choices = document.createElement('div'), toggle = document.createElement('button');
    field.className = 'ws-bundle-field'; choices.className = 'ws-bundle-colours'; choices.setAttribute('role', 'group');
    var colourLabel = fieldLabel(customLabel || 'Colore:', '<path d="M12 3a9 9 0 1 0 0 18c1.4 0 2-1.6 1.1-2.5-.8-.8-.2-2.2 1-2.2H17a4 4 0 0 0 4-4C21 7.2 17 3 12 3z"></path><circle cx="8" cy="11" r="1"></circle><circle cx="11" cy="7.5" r="1"></circle><circle cx="15.5" cy="9" r="1"></circle>');
    var selectedColour = state.colour && values(option).some(function (value) { return norm(valueLabel(value)) === norm(state.colour); }) ? state.colour : valueLabel(values(option)[0]);
    field.appendChild(colourLabel);
    values(option).forEach(function (value, index) {
      var label = valueLabel(value), image = valueImage(value), button = document.createElement('button');
      if (!label) return;
      button.type = 'button'; button.className = 'ws-bundle-colour'; button.title = label; button.setAttribute('aria-label', label); button.setAttribute('aria-pressed', norm(label) === norm(selectedColour) ? 'true' : 'false');
      button.innerHTML = image ? '<img loading="lazy" alt="">' : '<span></span>';
      if (image) { button.firstElementChild.src = image; button.firstElementChild.alt = label; } else button.firstElementChild.textContent = label.slice(0, 3).toUpperCase();
      button.addEventListener('click', function () {
        Array.prototype.forEach.call(choices.children, function (item) { item.setAttribute('aria-pressed', 'false'); });
        button.setAttribute('aria-pressed', 'true'); state.colour = label; colourLabel.querySelector('[data-ws-bundle-field-value]').textContent = label; changed();
      });
      choices.appendChild(button);
    });
    state.colour = selectedColour;
    colourLabel.querySelector('[data-ws-bundle-field-value]').textContent = selectedColour;
    toggle.type = 'button'; toggle.className = 'ws-bundle-colours-toggle'; toggle.hidden = true; toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = 'Mostra tutti i colori';
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      choices.classList.toggle('is-expanded', expanded);
      toggle.textContent = expanded ? 'Mostra meno' : 'Mostra tutti i colori';
    });
    field.appendChild(choices); field.appendChild(toggle); parent.appendChild(field);
    function syncToggleVisibility() {
      var perRow = Math.max(1, Math.floor((choices.clientWidth + 8) / 60));
      toggle.hidden = choices.children.length <= perRow * 2;
    }
    window.requestAnimationFrame(syncToggleVisibility);
    window.setTimeout(syncToggleVisibility, 120);
    if (window.ResizeObserver) new ResizeObserver(syncToggleVisibility).observe(choices);
    return true;
  }
  function renderSizes(parent, option, state, changed) {
    var sizes = sizesFrom(option); if (!sizes.length) return false;
    var field = document.createElement('div'), list = document.createElement('div'), footer = document.createElement('div'), error = document.createElement('div');
    field.className = 'ws-bundle-field'; list.className = 'ws-bundle-size-list'; list.setAttribute('role', 'group');
    var sizeLabel = fieldLabel('Taglia:', '<path d="M3 17 17 3l4 4L7 21 3 17z"></path><path d="m14 6 4 4M11 9l2 2M8 12l2 2M5 15l2 2"></path>');
    field.appendChild(sizeLabel);
    sizes.forEach(function (size) {
      var row = document.createElement('label'), input = document.createElement('input'), code = size.code || size.name;
      row.className = 'ws-bundle-size';
      row.innerHTML = '<span class="ws-bundle-size__badge"></span><span class="ws-bundle-size__name"></span>';
      row.children[0].textContent = code; row.children[1].textContent = size.name;
      input.className = 'ws-bundle-size__qty'; input.type = 'number'; input.min = '0'; input.value = '0'; input.inputMode = 'numeric'; input.setAttribute('aria-label', 'Quantità taglia ' + code);
      if (state.sizeLimit > 0) input.max = String(state.sizeLimit);
      input.addEventListener('input', function () {
        var quantity = toInt(input.value);
        if (String(quantity) !== input.value && input.value !== '') input.value = String(quantity);
        state.sizes[code] = quantity;
        state.sizeTotal = Object.keys(state.sizes).reduce(function (total, key) { return total + state.sizes[key]; }, 0);
        state.sizeOver = state.sizeLimit > 0 && state.sizeTotal > state.sizeLimit;
        state.size = Object.keys(state.sizes).filter(function (key) { return state.sizes[key] > 0; }).map(function (key) { return key + ':' + state.sizes[key]; }).join(', ');
        sizeLabel.querySelector('[data-ws-bundle-field-value]').textContent = state.size;
        footer.querySelector('strong').textContent = state.sizeLimit > 0 ? state.sizeTotal + '/' + state.sizeLimit : String(state.sizeTotal);
        error.hidden = !state.sizeOver;
        error.textContent = state.sizeOver ? 'Hai superato il limite di ' + state.sizeLimit + ' prodotti. Riduci le quantità per continuare.' : '';
        changed();
      });
      row.appendChild(input); list.appendChild(row);
    });
    footer.className = 'ws-bundle-size-total'; footer.innerHTML = '<span>Totale assegnato</span><strong>' + (state.sizeLimit > 0 ? '0/' + state.sizeLimit : '0') + '</strong>';
    error.className = 'ws-bundle-size-error'; error.hidden = true; error.setAttribute('role', 'alert');
    field.appendChild(list); field.appendChild(footer); field.appendChild(error); parent.appendChild(field); return true;
  }
  function renderOneSize(parent, option, state) {
    var sizes = sizesFrom(option); if (!sizes.length) return false;
    var size = sizes[0], field = document.createElement('div'), row = document.createElement('div');
    field.className = 'ws-bundle-field'; row.className = 'ws-bundle-size';
    var sizeLabel = fieldLabel('Taglia:', '<path d="M3 17 17 3l4 4L7 21 3 17z"></path><path d="m14 6 4 4M11 9l2 2M8 12l2 2M5 15l2 2"></path>');
    row.innerHTML = '<span class="ws-bundle-size__badge"></span><span class="ws-bundle-size__name"></span>';
    row.children[0].textContent = size.code || 'TU'; row.children[1].textContent = size.name;
    state.sizeTotal = state.sizeLimit > 0 ? state.sizeLimit : 1;
    state.size = size.code || size.name;
    sizeLabel.querySelector('[data-ws-bundle-field-value]').textContent = state.size;
    field.appendChild(sizeLabel); field.appendChild(row); parent.appendChild(field); return true;
  }
  function renderNativeOptions(parent, state, changed) {
    var rendered = false;
    (state.nativeOptions || []).forEach(function (option) {
      if (state.excludedNativeSelections[option.name]) return;
      var optionValues = Array.isArray(option.values) ? option.values : [];
      if (!option.name || !optionValues.length || option.name === 'Title' && optionValues[0] === 'Default Title') return;
      var field = document.createElement('div'), wrap = document.createElement('div'), select = document.createElement('select');
      field.className = 'ws-bundle-field'; wrap.className = 'ws-bundle-select-wrap';
      var selected = state.nativeSelections[option.name] || optionValues[0];
      var nativeIcon = norm(option.name).indexOf('quantit') >= 0 ? '<path d="M4 7l8-4 8 4-8 4-8-4zM4 7v10l8 4 8-4V7M12 11v10"></path>' : norm(option.name).indexOf('dimension') >= 0 ? '<path d="M3 17 17 3l4 4L7 21 3 17z"></path><path d="m14 6 4 4M11 9l2 2M8 12l2 2"></path>' : '<path d="M4 7h16M4 12h16M4 17h16"></path>';
      var label = fieldLabel(option.name + ':', nativeIcon);
      optionValues.forEach(function (value) {
        var node = document.createElement('option'); node.value = value; node.textContent = value; node.selected = value === selected; select.appendChild(node);
      });
      state.nativeSelections[option.name] = select.value;
      label.querySelector('[data-ws-bundle-field-value]').textContent = select.value;
      select.addEventListener('change', function () {
        state.nativeSelections[option.name] = select.value;
        label.querySelector('[data-ws-bundle-field-value]').textContent = select.value;
        changed();
      });
      wrap.appendChild(select); field.appendChild(label); field.appendChild(wrap); parent.appendChild(field); rendered = true;
    });
    return rendered;
  }
  function renderExtraOptions(parent, options, state, changed, hasShape) {
    var rendered = false;
    var conditionalFields = [];
    var materialInfo = {
      'Banner PVC 510g': { description: 'Resistente, ideale per esterni', badge: 'Standard' },
      'Telo Nautico 120g': { description: 'leggero, adatto all’esposizione al vento', badge: 'Standard' }
    };
    var finishingInfo = {
      'Solo Rifilo': { description: 'Taglio netto senza rinforzi', badge: '' },
      'Rinforzo ed Occhielli': { description: 'Bordi rinforzati con occhielli ogni 50 cm', badge: 'Incluso' },
      'Asola Superiore': { description: 'Asola rinforzata sul lato superiore', badge: '' },
      'Asole Verticali': { description: 'Asole rinforzate su lati superiore e inferiore', badge: '' },
      'Asole laterali': { description: 'Asole rinforzate sui lati destro e sinistro', badge: '' },
      'Asola Superiore e Inferiore': { description: 'Asole rinforzate su lati superiore e inferiore', badge: '' },
      'Asole Laterali': { description: 'Asole rinforzate sui lati destro e sinistro', badge: '' }
    };
    options.forEach(function (option) {
      var title = option && (option.title || option.name || option.label) || '';
      var normalized = optionTitle(option), optionValues = values(option);
      var special = hasShape ? /forma toppa|posizione|colore|taglia/.test(normalized) : /posizione|colore|taglia/.test(normalized);
      if (!title || !optionValues.length || option.type === 'instructions' || special) return;
      var isFormat = normalized === 'formato', isMaterial = normalized.indexOf('materiale') >= 0, isFinishing = normalized.indexOf('lavorazioni') >= 0 && normalized.indexOf('rifiniture') >= 0;
      var icon = isFormat ? '<path d="M5 4h14v16H5zM8 8h8M8 12h8M8 16h5"></path>' : isMaterial ? '<path d="M4 8l8-4 8 4-8 4-8-4zM4 12l8 4 8-4M4 16l8 4 8-4"></path>' : isFinishing ? '<circle cx="12" cy="12" r="3"></circle><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2"></path>' : '<path d="M5 7h14M5 12h14M5 17h14"></path>';
      var field = document.createElement('div'), label = fieldLabel(title + ':', icon);
      var selected = state.extraSelections[title] || option.preselect_value || valueLabel(optionValues[0]);
      field.className = 'ws-bundle-field'; field.appendChild(label);
      function choose(value) {
        state.extraSelections[title] = value;
        var selectedValue = optionValues.find(function (candidate) { return valueLabel(candidate) === value; });
        state.extraPrices[title] = valuePriceCents(selectedValue) * state.componentQuantity;
        label.querySelector('[data-ws-bundle-field-value]').textContent = value;
        refreshConditionalFields();
        changed();
      }
      if (isFormat) {
        var choices = document.createElement('div'); choices.className = 'ws-bundle-format'; choices.setAttribute('role', 'group');
        optionValues.forEach(function (value) {
          var valueText = valueLabel(value), button = document.createElement('button'), vertical = /vertical/i.test(valueText);
          if (!valueText) return;
          button.type = 'button'; button.className = 'ws-bundle-format__choice'; button.setAttribute('aria-pressed', String(valueText === selected));
          button.innerHTML = '<span class="ws-bundle-format__ui"><span class="ws-bundle-format__visual ws-bundle-format__visual--' + (vertical ? 'vertical' : 'horizontal') + '"></span><span class="ws-bundle-format__name"></span></span>';
          button.querySelector('.ws-bundle-format__name').textContent = valueText;
          button.addEventListener('click', function () {
            Array.prototype.forEach.call(choices.children, function (item) { item.setAttribute('aria-pressed', 'false'); });
            button.setAttribute('aria-pressed', 'true'); choose(valueText);
          });
          choices.appendChild(button);
        });
        field.appendChild(choices);
      } else if (isMaterial) {
        var materials = document.createElement('div'); materials.className = 'ws-bundle-material';
        optionValues.forEach(function (value) {
          var valueText = valueLabel(value), info = materialInfo[valueText] || {}, button = document.createElement('button');
          if (!valueText) return;
          button.type = 'button'; button.className = 'ws-bundle-material__choice'; button.setAttribute('aria-pressed', String(valueText === selected));
          button.innerHTML = '<span class="ws-bundle-material__info"><span class="ws-bundle-material__name"></span><span class="ws-bundle-material__desc"></span></span><span class="ws-bundle-material__badge"></span>';
          button.querySelector('.ws-bundle-material__name').textContent = valueText;
          button.querySelector('.ws-bundle-material__desc').textContent = info.description || '';
          button.querySelector('.ws-bundle-material__badge').textContent = info.badge || '';
          button.addEventListener('click', function () { choose(valueText); }); materials.appendChild(button);
        });
        field.appendChild(materials);
      } else if (isFinishing) {
        var finishings = document.createElement('div'); finishings.className = 'ws-bundle-finishing'; finishings.setAttribute('role', 'radiogroup');
        optionValues.forEach(function (value) {
          var valueText = valueLabel(value), info = finishingInfo[valueText] || {}, button = document.createElement('button');
          if (!valueText) return;
          button.type = 'button'; button.className = 'ws-bundle-finishing__choice'; button.setAttribute('aria-pressed', String(valueText === selected));
          button.innerHTML = '<span class="ws-bundle-finishing__radio"><span class="ws-bundle-finishing__dot"></span></span><span class="ws-bundle-finishing__content"><span class="ws-bundle-finishing__header"><span class="ws-bundle-finishing__name"></span><span class="ws-bundle-finishing__badge"></span></span><span class="ws-bundle-finishing__desc"></span></span>';
          button.querySelector('.ws-bundle-finishing__name').textContent = valueText;
          button.querySelector('.ws-bundle-finishing__badge').textContent = info.badge || '';
          button.querySelector('.ws-bundle-finishing__desc').textContent = info.description || '';
          button.addEventListener('click', function () {
            Array.prototype.forEach.call(finishings.children, function (item) { item.setAttribute('aria-pressed', 'false'); });
            button.setAttribute('aria-pressed', 'true'); choose(valueText);
          });
          finishings.appendChild(button);
        });
        field.appendChild(finishings);
      } else {
        var list = document.createElement('div'); list.className = 'ws-bundle-choice-list'; list.setAttribute('role', 'group');
        optionValues.forEach(function (value) {
          var valueText = valueLabel(value), button = document.createElement('button');
          if (!valueText) return;
          button.type = 'button'; button.className = 'ws-bundle-choice'; button.textContent = valueText; button.setAttribute('aria-pressed', String(valueText === selected));
          button.addEventListener('click', function () {
            Array.prototype.forEach.call(list.children, function (item) { item.setAttribute('aria-pressed', 'false'); });
            button.setAttribute('aria-pressed', 'true'); choose(valueText);
          });
          list.appendChild(button);
        });
        field.appendChild(list);
      }
      state.extraSelections[title] = selected;
      var initialValue = optionValues.find(function (candidate) { return valueLabel(candidate) === selected; });
      state.extraPrices[title] = valuePriceCents(initialValue) * state.componentQuantity;
      label.querySelector('[data-ws-bundle-field-value]').textContent = selected;
      parent.appendChild(field);
      conditionalFields.push({ field: field, option: option, title: title });
      rendered = true;
    });
    function conditionalSelection(option) {
      var reference = String(option && option.conditional_option || '');
      if (!reference) return '';
      if (/^\d+$/.test(reference)) {
        var nativeOption = state.nativeOptions[Number(reference)];
        return nativeOption ? state.nativeSelections[nativeOption.name] : '';
      }
      var parentOption = options.find(function (candidate) { return candidate && String(candidate.unique || '') === reference; });
      var parentTitle = parentOption && (parentOption.title || parentOption.name || parentOption.label);
      return parentTitle ? state.extraSelections[parentTitle] : '';
    }
    function refreshConditionalFields() {
      conditionalFields.forEach(function (item) {
        var expected = item.option && item.option.conditional_value;
        var active = !expected || norm(conditionalSelection(item.option)) === norm(expected);
        item.field.hidden = !active;
        state.extraActive[item.title] = active;
      });
    }
    state.refreshExtraConditions = refreshConditionalFields;
    refreshConditionalFields();
    return rendered;
  }
  function renderHatOptions(parent, options, state, changed) {
    var shape = findOption(options, 'forma toppa');
    if (!shape) return false;
    var position = findOption(options, 'posizione') || { title: 'Posizione stampa', values: ['Fronte'] };
    var rectangularColour = options.find(function (option) { return optionTitle(option).indexOf('colore berretti toppa rettangolare') >= 0; });
    var circularColour = options.find(function (option) { return optionTitle(option).indexOf('colore berretti toppa circolare') >= 0; });
    var size = findOption(options, 'taglia'), dependants = document.createElement('div');
    state.hasShape = true; state.positionRequired = !!position;
    if (position) renderPosition(parent, position, state, changed);
    renderShape(parent, shape, state, function () { renderDependants(); changed(); });
    parent.appendChild(dependants);
    function renderDependants() {
      dependants.innerHTML = '';
      state.colour = ''; state.size = ''; state.sizeTotal = 0; state.hasColour = false; state.hasSize = false;
      var rectangular = norm(state.shape).indexOf('rettangolare') >= 0;
      var colour = rectangular ? rectangularColour : circularColour;
      state.colourProperty = colour ? (colour.title || colour.name || colour.label || '') : '';
      state.hasColour = !!colour;
      if (colour) renderColours(dependants, colour, state, changed, state.colourProperty + ':');
      if (size) {
        state.hasSize = true;
        if (isOneSizeOption(size)) renderOneSize(dependants, size, state);
        else renderSizes(dependants, size, state, changed);
      }
    }
    renderDependants();
    return true;
  }
  function initialise(root) {
    if (root.dataset.wsBundleReady === '1') return; root.dataset.wsBundleReady = '1';
    var flatMode = root.getAttribute('data-ws-bundle-flat') === 'true';
    window.__wsBundleProperties = {};
    root.setAttribute('data-ws-bundle-values', '{}');
    var slot = document.getElementById('ws-bcpo-slot');
    if (slot) {
      slot.setAttribute('data-ws-bundle-replaced', 'true');
      slot.insertAdjacentElement('afterend', root);
    }
    root.hidden = false;
    var variants = json(root, '[data-ws-bundle-variants]', []), propertyRoot = root.querySelector('[data-ws-bundle-properties]');
    var globalOptions = Array.prototype.slice.call(root.querySelectorAll('[data-ws-bundle-global-option]'));
    var fallbackLimits = document.querySelector('#ws-pack-limits[data-pack-limits]');
    var packLimits = parsePackLimits(root.getAttribute('data-pack-limits') || (fallbackLimits ? fallbackLimits.getAttribute('data-pack-limits') : ''));
    var bundleProperties = {}, discoveringComponent = false;
    function selectedGlobalQuantity() {
      var option = globalOptions.find(function (candidate) { return norm(candidate.getAttribute('data-option-name')) === 'quantita'; });
      var active = option && option.querySelector('[data-ws-bundle-global-value][aria-pressed="true"]');
      var quantity = parseInt(active && active.value || '', 10);
      return quantity > 0 ? quantity : 0;
    }
    function stateForNode(node, component) {
      var select = node.querySelector('[data-ws-bundle-position]');
      var title = node.getAttribute('data-component-title'), packKey = packKeyForTitle(title, packLimits), supplemental = node.getAttribute('data-ws-bundle-supplemental') === 'true';
      var nativeSelections = {};
      var configuredLimit = packKey ? packLimits[packKey] : 0;
      var globalQuantity = selectedGlobalQuantity();
      (component && component.selectedOptions || []).forEach(function (option) { nativeSelections[option.name] = option.value; });
      return { node: node, title: title, handle: component && component.handle || '', index: Number(node.getAttribute('data-option-index')), supplemental: supplemental, componentQuantity: component && Number(component.quantity) || 1, positionRequired: !!select, position: select ? select.value : '', shape: '', colour: '', colourProperty: '', size: '', sizes: {}, sizeTotal: 0, sizeLimit: globalQuantity || configuredLimit, baseSizeLimit: configuredLimit, sizeOver: false, packKey: packKey, hasShape: false, hasColour: false, hasSize: false, nativeOptions: component && component.nativeOptions || [], nativeSelections: nativeSelections, excludedNativeSelections: {}, extraSelections: {}, extraPrices: {}, extraActive: {}, refreshExtraConditions: null, loaded: false, loading: false };
    }
    var states = Array.prototype.slice.call(root.querySelectorAll('[data-ws-bundle-product]')).map(function (node) { return stateForNode(node); });
    function property(name, value) {
      window.__wsBundleProperties = window.__wsBundleProperties || {};
      if (value) { window.__wsBundleProperties[name] = value; bundleProperties[name] = value; }
      else { delete window.__wsBundleProperties[name]; delete bundleProperties[name]; }
      root.setAttribute('data-ws-bundle-values', JSON.stringify(bundleProperties));
      var input = Array.prototype.find.call(propertyRoot.children, function (item) { return item.getAttribute('data-property-name') === name; });
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'properties[' + name.replace(/[\[\]]/g, '') + ']'; input.setAttribute('data-property-name', name); input.setAttribute('form', root.getAttribute('data-form-id')); propertyRoot.appendChild(input); }
      input.value = value || ''; input.setAttribute('value', value || ''); input.disabled = !value;
    }
    function money(cents) {
      return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format((cents || 0) / 100);
    }
    function syncBundleUnitPrice(price) {
      document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
        var input = form.querySelector('input[name="properties[_ws_bundle_unit_price_cents]"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[_ws_bundle_unit_price_cents]';
          input.setAttribute('data-ws-bundle-unit-price', '1');
          form.appendChild(input);
        }
        input.value = String(price);
        input.setAttribute('value', String(price));
        input.disabled = false;
      });
    }
    function syncSummary(variant) {
      var addon = states.reduce(function (total, state) {
        return total + Object.keys(state.extraPrices).reduce(function (stateTotal, title) {
          return stateTotal + (state.extraActive[title] === false ? 0 : state.extraPrices[title]);
        }, 0);
      }, 0);
      window.__wsBundleAddonCents = addon;
      var basePrice = Number(variant.price) || 0;
      var price = basePrice + addon;
      var compare = Math.max(basePrice, Number(variant.compare_at_price) || 0) + addon;
      syncBundleUnitPrice(price);
      var total = document.querySelector('[data-ws-summary-total] .money') || document.querySelector('[data-ws-summary-total]');
      var subtotal = document.querySelector('[data-ws-summary-subtotal]');
      var baseCents = document.querySelector('[data-ws-base-product-cents]');
      var compareCents = document.querySelector('[data-ws-compare-product-cents]');
      if (total) total.textContent = money(price);
      if (subtotal) subtotal.textContent = money(compare);
      if (baseCents) baseCents.textContent = price;
      if (compareCents) compareCents.textContent = compare;
      window.dispatchEvent(new CustomEvent('ws:bundle-price-change', { detail: { addonCents: addon } }));
    }
    function syncVariant() {
      var selected = [];
      globalOptions.forEach(function (option) {
        var active = option.querySelector('[data-ws-bundle-global-value][aria-pressed="true"]');
        selected[Number(option.getAttribute('data-option-index'))] = active ? active.value : '';
      });
      states.filter(function (state) { return !state.supplemental; }).forEach(function (state) {
        selected[state.index] = state.position;
      });
      // Bundles with only "Default Title" have no native option state to match.
      var variant = selected.length === 0 && variants.length === 1 ? variants[0] : variants.find(function (candidate) { return candidate.options && candidate.options.every(function (value, index) { return value === selected[index]; }); });
      if (!variant) return;
      window.__wsBundleSelectedVariantId = String(variant.id);
      root.setAttribute('data-ws-selected-variant-id', String(variant.id));
      document.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (input) { input.value = variant.id; input.setAttribute('value', variant.id); });
      syncSummary(variant);
      window.dispatchEvent(new CustomEvent('ws:bundle-variant-change', { detail: { variant: variant } }));
    }
    function complete(state) {
      var sizesComplete = !state.hasSize || (state.sizeLimit > 0 ? state.sizeTotal === state.sizeLimit : state.sizeTotal > 0);
      return state.loaded && (!state.positionRequired || state.position) && (!state.hasShape || state.shape) && (!state.hasColour || state.colour) && sizesComplete && !state.sizeOver;
    }
    function syncCta() {
      var allComplete = !discoveringComponent && states.length > 0 && states.every(complete);
      var button = document.querySelector('#ws-product-form-summary .ws-cta__btn');

      root.setAttribute('data-ws-bundle-complete', allComplete ? 'true' : 'false');
      if (!button) return;
      if (/aggiunta in corso/i.test(button.textContent || '')) return;

      // The duplicated kit template has a legacy size validator that disables every
      // add-to-cart button. On bundle pages this configurator owns completeness.
      if (button.disabled !== !allComplete) button.disabled = !allComplete;
      if (button.getAttribute('aria-disabled') !== (allComplete ? 'false' : 'true')) button.setAttribute('aria-disabled', allComplete ? 'false' : 'true');
      if (button.style.cursor !== (allComplete ? '' : 'not-allowed')) button.style.cursor = allComplete ? '' : 'not-allowed';
      if (button.style.opacity !== (allComplete ? '' : '0.6')) button.style.opacity = allComplete ? '' : '0.6';
    }
    function bindCtaState() {
      var summary = document.querySelector('[data-ws-order-summary]');
      if (!summary || root.dataset.wsBundleCtaObserver === '1') return false;
      root.dataset.wsBundleCtaObserver = '1';
      new MutationObserver(function () { window.setTimeout(syncCta, 0); }).observe(summary, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['disabled', 'aria-disabled', 'style']
      });
      syncCta();
      return true;
    }
    function update(state) {
      if (state.refreshExtraConditions) state.refreshExtraConditions();
      var status = state.node.querySelector('[data-ws-bundle-status]'), done = complete(state); state.node.classList.toggle('is-complete', !!done);
      var nativeValues = Object.keys(state.nativeSelections).filter(function (key) { return !state.excludedNativeSelections[key]; }).map(function (key) { return state.nativeSelections[key]; });
      var extraValues = Object.keys(state.extraSelections).filter(function (key) { return state.extraActive[key] !== false; }).map(function (key) { return state.extraSelections[key]; });
      status.textContent = !state.loaded ? (state.loading ? 'Caricamento...' : 'Da configurare') : done ? (nativeValues.concat(extraValues, [state.position, state.shape, state.colour, state.size]).filter(Boolean).join(' · ') || 'Configurazione completata') : state.hasSize && state.sizeLimit > 0 ? 'Assegna le taglie: ' + state.sizeTotal + '/' + state.sizeLimit : 'Completa le opzioni';
      syncVariant();
      if (state.hasShape) {
        var rectangular = norm(state.shape).indexOf('rettangolare') >= 0;
        property(state.title + ' · Posizione stampa', state.position);
        property(state.title + ' · Forma Toppa', state.shape);
        property(state.title + ' · Colore', '');
        property(state.title + ' · Colore Berretti Toppa Rettangolare', rectangular ? state.colour : '');
        property(state.title + ' · Colore Berretti Toppa Circolare', rectangular ? '' : state.colour);
      } else {
        property(state.title + ' · Posizione stampa', state.position);
        property(state.title + ' · Colore', state.colour);
      }
      property(state.title + ' · Taglia', state.size);
      var globalQuantity = selectedGlobalQuantity();
      property(state.title + ' · Quantità', globalQuantity > 0 ? String(globalQuantity) : '');
      Object.keys(state.nativeSelections).forEach(function (name) { property(state.title + ' · ' + name, state.excludedNativeSelections[name] ? '' : state.nativeSelections[name]); });
      Object.keys(state.extraSelections).forEach(function (name) {
        var active = state.extraActive[name] !== false;
        var price = state.extraPrices[name] || 0;
        var value = active ? state.extraSelections[name] : '';
        property(state.title + ' · ' + name, value && price > 0 ? value + ' | ' + money(price) : value);
      });
      syncCta();
      window.setTimeout(syncCta, 0);
    }
    var wsQtyComponents = null; function wsQtyFor(state) { if (state.nativeOptions && state.nativeOptions.length) return Promise.resolve(); wsQtyComponents = wsQtyComponents || loadBundleComponents(root.getAttribute('data-parent-variant-id')).catch(function () { return []; }); return wsQtyComponents.then(function (cs) { var c = (cs || []).find(function (x) { return norm(x.title) === norm(state.title); }); if (!c) return; state.nativeOptions = state.nativeOptions || []; (c.selectedOptions || []).forEach(function (o) { var n = String(o.name || '').trim(); if (norm(n).indexOf('quantit') !== 0) return; state.nativeOptions.push({ name: n, values: [o.value] }); state.nativeSelections[n] = o.value; }); }).catch(function () {}); } function load(state) {
      if (state.loaded || state.loading) return; state.loading = true; update(state);
      wsQtyFor(state).then(function () { return loadComponent(state.title, state.handle); }).then(function (data) {
        var dynamic = state.node.querySelector('[data-ws-bundle-dynamic]'), options = data.options || [], shape = findOption(options, 'forma toppa'), position = state.supplemental ? findOption(options, 'posizione') : null, colour = findOption(options, 'colore'), size = findOption(options, 'taglia'); dynamic.innerHTML = '';
        state.nativeOptions.forEach(function (nativeOption) {
          state.excludedNativeSelections[nativeOption.name] = !!shape && optionTitle(nativeOption).indexOf('posizione') >= 0;
        });
        var renderedNative = renderNativeOptions(dynamic, state, function () { update(state); });
        var renderedExtra = (flatMode || state.supplemental) && renderExtraOptions(dynamic, options, state, function () { update(state); }, !!shape);
        if (shape) {
          renderHatOptions(dynamic, options, state, function () { update(state); });
          state.loaded = true; state.loading = false; update(state); return;
        }
        if (size && isOneSizeOption(size)) size = null;
        state.positionRequired = !state.supplemental || !!position;
        state.hasColour = !!colour; state.hasSize = !!size;
        if (position) renderPosition(dynamic, position, state, function () { update(state); });
        if (colour) renderColours(dynamic, colour, state, function () { update(state); });
        if (size) renderSizes(dynamic, size, state, function () { update(state); });
        if (!renderedNative && !renderedExtra && !position && !colour && !size) dynamic.innerHTML = '<div class="ws-bundle-loading">Nessuna opzione aggiuntiva richiesta.</div>';
        state.loaded = true; state.loading = false; update(state);
      }).catch(function (error) {
        state.loading = false; state.node.querySelector('[data-ws-bundle-dynamic]').innerHTML = '<div class="ws-bundle-error">' + error.message + '. Ricarica la pagina per riprovare.</div>'; update(state);
      });
    }
    function activate(state) {
      var toggle = state.node.querySelector('[data-ws-bundle-toggle]'), panel = state.node.querySelector('[data-ws-bundle-panel]'), select = state.node.querySelector('[data-ws-bundle-position]');
      var initialPositionValue = state.node.querySelector('[data-ws-bundle-position-value]');
      if (initialPositionValue) initialPositionValue.textContent = state.position;
      if (flatMode) {
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-disabled', 'true');
        toggle.tabIndex = -1;
        panel.hidden = false;
        state.node.classList.add('is-open');
        load(state);
      } else {
        toggle.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        state.node.classList.add('is-open');
        load(state);
        toggle.addEventListener('click', function () { var open = toggle.getAttribute('aria-expanded') !== 'true'; toggle.setAttribute('aria-expanded', String(open)); panel.hidden = !open; state.node.classList.toggle('is-open', open); if (open) load(state); });
      }
      if (select) select.addEventListener('change', function () {
        state.position = select.value;
        var positionValue = state.node.querySelector('[data-ws-bundle-position-value]');
        if (positionValue) positionValue.textContent = state.position;
        update(state);
      }); update(state);
    }
    function refreshSizeLimit(state) {
      state.sizeOver = state.sizeLimit > 0 && state.sizeTotal > state.sizeLimit;
      Array.prototype.forEach.call(state.node.querySelectorAll('.ws-bundle-size__qty'), function (input) {
        if (state.sizeLimit > 0) input.max = String(state.sizeLimit);
        else input.removeAttribute('max');
      });
      var total = state.node.querySelector('.ws-bundle-size-total strong');
      if (total) total.textContent = state.sizeLimit > 0 ? state.sizeTotal + '/' + state.sizeLimit : String(state.sizeTotal);
      var error = state.node.querySelector('.ws-bundle-size-error');
      if (error) {
        error.hidden = !state.sizeOver;
        error.textContent = state.sizeOver ? 'Hai superato il limite di ' + state.sizeLimit + ' prodotti. Riduci le quantità per continuare.' : '';
      }
    }
    function bindGlobalOptions() {
      globalOptions.forEach(function (option) {
        var buttons = Array.prototype.slice.call(option.querySelectorAll('[data-ws-bundle-global-value]'));
        var label = option.querySelector('[data-ws-bundle-global-value-label]');
        var optionName = option.getAttribute('data-option-name') || 'Quantità';
        function selectValue(button, refreshStates) {
          buttons.forEach(function (candidate) {
            var selected = candidate === button;
            candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
            candidate.setAttribute('aria-checked', selected ? 'true' : 'false');
          });
          if (label) label.textContent = button.value;
          if (norm(optionName) === 'quantita') {
            var quantity = parseInt(button.value, 10);
            if (quantity > 0) states.forEach(function (state) {
              state.sizeLimit = quantity;
              if (state.hasSize && !state.node.querySelector('.ws-bundle-size__qty')) state.sizeTotal = quantity;
              refreshSizeLimit(state);
            });
          }
          syncVariant();
          if (refreshStates) states.forEach(update);
        }
        buttons.forEach(function (button) {
          button.addEventListener('click', function () { selectValue(button, true); });
        });
        var initial = option.querySelector('[data-ws-bundle-global-value][aria-pressed="true"]') || buttons[0];
        if (initial) selectValue(initial, false);
      });
    }
    bindGlobalOptions();
    states.forEach(activate);
    var hasOnlyDefaultVariant = variants.length === 1 && variants[0].options && variants[0].options.length === 1 && variants[0].options[0] === 'Default Title';
    var shouldDiscoverComponents = !states.length || hasOnlyDefaultVariant && states.every(function (state) { return state.supplemental; });
    if (shouldDiscoverComponents) {
      discoveringComponent = true; syncCta();
      loadBundleComponents(root.getAttribute('data-parent-variant-id')).then(function (components) {
        var products = root.querySelector('.ws-bundle-products');
        products.innerHTML = '';
        states.length = 0;
        (flatMode ? components.slice(0, 1) : components).forEach(function (component, index) {
          var node = document.createElement('section');
          node.className = 'ws-bundle-product'; node.setAttribute('data-ws-bundle-product', ''); node.setAttribute('data-ws-bundle-supplemental', 'true'); node.setAttribute('data-component-title', component.title);
          node.innerHTML = '<button type="button" class="ws-bundle-product__toggle" aria-expanded="false" data-ws-bundle-toggle><span class="ws-bundle-product__number"></span><span class="ws-bundle-product__heading"><strong></strong><small data-ws-bundle-status>Da configurare</small></span><span class="ws-bundle-product__chevron" aria-hidden="true"></span></button><div class="ws-bundle-product__panel" data-ws-bundle-panel hidden><div class="ws-bundle-product__dynamic" data-ws-bundle-dynamic><div class="ws-bundle-loading" role="status">Caricamento delle opzioni prodotto...</div></div></div>';
          node.querySelector('.ws-bundle-product__number').textContent = String(index + 1);
          node.querySelector('.ws-bundle-product__heading strong').textContent = component.title;
          products.appendChild(node);
          var state = stateForNode(node, component); states.push(state); activate(state);
        });
        discoveringComponent = false; syncVariant(); syncCta();
      }).catch(function (error) {
        discoveringComponent = false;
        if (!states.length) root.querySelector('.ws-bundle-products').innerHTML = '<div class="ws-bundle-error" role="alert">' + error.message + '. Verifica il collegamento Shopify Bundles e ricarica la pagina.</div>';
        syncCta();
      });
    }
    function stopIncomplete(event) { if (!document.documentElement.contains(root)) return false;
      // The summary form is rendered after the configurator and can replace its
      // hidden variant input, so refresh it at the exact moment of submission.
      syncVariant();
      var missing = states.find(function (state) { return !complete(state); });
      if (!missing) return false;
      event.preventDefault(); event.stopImmediatePropagation();
      var toggle = missing.node.querySelector('[data-ws-bundle-toggle]');
      if (flatMode) load(missing);
      else if (toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
      missing.node.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return true;
    }
    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest && event.target.closest('#ws-product-form-summary button[type="submit"], #ws-product-form-summary [data-ws-cta-guard]');
      if (target) stopIncomplete(event);
    }, true);
    function bindForm() {
      var form = document.getElementById(root.getAttribute('data-form-id'));
      if (!form || form.dataset.wsBundleValidationBound === '1') return false;
      form.dataset.wsBundleValidationBound = '1';
      form.addEventListener('submit', stopIncomplete, true);
      return true;
    }
    if (!bindForm()) {
      var bindAttempts = 0;
      var bindTimer = setInterval(function () { bindAttempts += 1; if (bindForm() || bindAttempts >= 40) clearInterval(bindTimer); }, 100);
    }
    if (!bindCtaState()) window.setTimeout(bindCtaState, 250);
    syncVariant();
  }
  function boot(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll(ROOT), initialise); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }); else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());
